import { useState } from "react";
import Slider from "react-slick";
// Import slick-carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PscImage1 from "../assets/psc1.jpg";
import PscImage2 from "../assets/psc2.jpg";
import PscImage3 from "../assets/psc3.jpg";
import PscImage4 from "../assets/psc4.jpg";
import PscImage5 from "../assets/psc5.jpg";
import PscImage6 from "../assets/psc6.jpg";
import PscImage7 from "../assets/psc7.jpg";
import PscImage8 from "../assets/psc8.jpg";
import PscImage9 from "../assets/psc9.jpg";
import PscImage10 from "../assets/psc10.jpg";
import PscImage11 from "../assets/psc11.jpg";
// import PscImage12 from "../assets/psc12.png";
import { X } from "lucide-react";

const ImageSlider = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    PscImage1,
    PscImage2,
    PscImage3,
    PscImage4,
    PscImage5,
    PscImage6,
    PscImage7,
    PscImage8,
    PscImage9,
    PscImage10,
    PscImage11,
  ];

  const openModal = (img) => {
    setSelectedImage(img);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const sliderSettings = {
    dots: true, // Show navigation dots
    infinite: true, // Loop the slider
    speed: 500, // Transition speed in ms
    slidesToShow: 3, // Show 3 slides at a time
    slidesToScroll: 1, // Scroll 1 slide at a time
    arrows: true, // Show next/prev arrows
    swipeToSlide: true, // Enable swipe to scroll
    autoplay: true, // Enable automatic sliding
    autoplaySpeed: 3000, // Auto-slide every 3 seconds
    responsive: [
      {
        breakpoint: 768, // At 768px or below
        settings: {
          slidesToShow: 1, // Show 1 slide
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="mt-6 md:mt-8">
      {/* Image Slider */}
      <Slider {...sliderSettings}>
        {images.map((img, index) => (
          <div key={index} className="px-2">
            <img
              src={img}
              alt={`Project Status ${index + 1}`}
              className="w-full h-64 object-cover rounded-lg shadow-lg cursor-pointer"
              onClick={() => openModal(img)}
            />
          </div>
        ))}
      </Slider>

      {/* Modal for Fullscreen Image Preview */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-6xl max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-50"
              onClick={closeModal}
            >
              <X className="w-6 h-6 mt-5" />
            </button>
            {/* Fullscreen Image */}
            <img
              src={selectedImage}
              alt="Fullscreen Preview"
              className="w-full h-full max-h-[90vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
